import { set } from "lodash";
import apiRequest from "../../shared/network/apiRequest";
import Resources from "../../shared/actions/resourcesActions";
import localStorage from "../../shared/helpers/localStorage";

export class UnitsResource extends Resources {
  constructor(dispatch) {
    // @todo: change bp route to mp
    super(dispatch, "unit", `/bp/api/v1/sample_units`);
  }

  get(id, deep) {
    const deepParameter = (deep && "?deep=true") || "";
    const url = `${this.url}/${id}${deepParameter}`;
    return apiRequest
      .get(url, this.dispatch)
      .then(response => {
        if (response.status === 200) {
          const buyerSelections =
            JSON.parse(localStorage.get("buyerSelections")) || {};
          set(response, ["data", "buyer_selections"], buyerSelections);
          const productLineSelection =
            JSON.parse(localStorage.get("productLineSelection")) || {};
          set(response, ["data", "product_line_selection"], {
            tag: productLineSelection[id]
          });

          return response;
        }
        return response;
      })
      .then(this.propagateUpdate.bind(this));
  }
}
